var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 67,
    viewBox: "0 0 57 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10.7969,
    width: 44.1973,
    height: 56.2512,
    rx: 3.14916,
    transform: "rotate(-13.472 0 10.7969)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9734_150759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.785 7.33907L23.7287 4.42497L22.0158 19.7408L7.12646 18.0756L2.92986 55.5993C2.74066 57.291 3.92051 58.8115 5.56514 58.9954L43.5329 63.2417C45.1776 63.4256 46.6642 62.2033 46.8534 60.5116L52.4203 10.7353C52.6095 9.04354 51.4296 7.52301 49.785 7.33907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0158 19.7408L23.7287 4.42497L7.12646 18.0756L22.0158 19.7408Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3114 25.6337L44.3234 29.2139L44.1521 30.7455L12.1401 27.1653L12.3114 25.6337Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6262 31.7601L43.6383 35.3402L43.467 36.8718L11.4549 33.2916L11.6262 31.7601Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9411 37.8864L34.764 40.5507L34.5927 42.0823L10.7698 39.418L10.9411 37.8864Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2559 44.0127L32.5899 46.5105L32.4186 48.0421L10.0846 45.5443L10.2559 44.0127Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9734_150759",
    x: 0.548044,
    y: 2.8512,
    width: 54.254,
    height: 63.5577,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.787289
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.18093
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9734_150759"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9734_150759",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.c1e5bf11a5f5928be57716245c33ba5e.svg";
export { ForwardRef as ReactComponent };